import React from "react";

const NO_IMAGE_PLACEHOLDER =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='152' height='152'%3E%3Crect width='152' height='152' fill='%23eee'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' fill='%23999' font-size='14'%3ENo Image%3C/text%3E%3C/svg%3E";

export interface ProductImageProps {
  logoUrl?: string;
  altText: string;
  size?: number;
  dataTestId?: string;
  className?: string;
}

/**
 * Renders a square product image with a consistent no-image placeholder fallback.
 * Used across the PDP, checkout side panel, and search results.
 */
export const ProductImage: React.FC<ProductImageProps> = ({
  logoUrl,
  altText,
  size = 110,
  dataTestId = "product-image",
  className,
}) => {
  const imageUrl = logoUrl?.trim() ? logoUrl : NO_IMAGE_PLACEHOLDER;

  return (
    <div
      className={className}
      style={{
        width: size,
        height: size,
        padding: 8,
        borderRadius: 16,
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img
        src={imageUrl}
        alt={altText}
        data-testid={dataTestId}
        style={{
          borderRadius: 16,
          width: "100%",
          height: "100%",
          objectFit: "contain",
        }}
      />
    </div>
  );
};
